import type { NumberFormatterOptions } from "../../../../../../../../../../api/types/fieldConfigurationTypes";
import { CalculationType } from "../../../../../../../../../../api/types/fieldConfigurationTypes";
import type { CustomColumnData } from "../customColumn.types";
import type { FormulaToken, ParsedCustomFormula } from "./customFormulaParser";

const serializeBackendFormula = (tokens: FormulaToken[], formulaParameters: string[]): string => {
  const parameterIndexByGuid = new Map<string, number>();
  formulaParameters.forEach((guid, index) => {
    parameterIndexByGuid.set(guid, index);
  });

  let result = "";
  let previousToken: FormulaToken | undefined = undefined;

  tokens.forEach((token) => {
    const appendWithOptionalSpace = (value: string): void => {
      if (
        result.length > 0 &&
        previousToken &&
        previousToken.kind !== "openParen" &&
        previousToken.kind !== "operator" &&
        previousToken.kind !== "comma"
      ) {
        result += " ";
      }
      result += value;
    };

    if (token.kind === "field") {
      const parameterIndex = parameterIndexByGuid.get(token.guid);
      const parameterPlaceholder = parameterIndex !== undefined ? `{${parameterIndex}}` : "{0}";
      appendWithOptionalSpace(parameterPlaceholder);
      previousToken = token;
      return;
    }

    if (token.kind === "function") {
      appendWithOptionalSpace(token.name);
      previousToken = token;
      return;
    }

    if (token.kind === "number") {
      appendWithOptionalSpace(token.value);
      previousToken = token;
      return;
    }

    if (token.kind === "operator") {
      result = result.trimEnd();
      result += ` ${token.value} `;
      previousToken = token;
      return;
    }

    if (token.kind === "openParen") {
      result = result.trimEnd();
      result += "(";
      previousToken = token;
      return;
    }

    if (token.kind === "closeParen") {
      result = result.trimEnd();
      result += ")";
      previousToken = token;
      return;
    }

    if (token.kind === "comma") {
      result = result.trimEnd();
      result += ", ";
      previousToken = token;
    }
  });

  return result.trim();
};

export const buildCustomFormulaApplyPayload = (
  name: string,
  parsedFormula: ParsedCustomFormula,
  format?: NumberFormatterOptions,
  blankIfMissingValue?: boolean
): CustomColumnData => {
  return {
    name,
    selectedFormulaParameterIds: parsedFormula.formulaParameters,
    selectedCalculationType: CalculationType.CustomFormula,
    formula: serializeBackendFormula(parsedFormula.tokens, parsedFormula.formulaParameters),
    format,
    blankIfMissingValue,
  };
};
